<template>
  <b-modal 
    id="modal-1"
    ref="modal"
    :title="title"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-title="Добавить регион"
    cancel-title="Отмена"
    cancel-variant="light"
    footer-class="justify-content-between"
  >
    <pre>{{ region }}</pre>
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group label="Название региона" label-for="title">
        <b-form-input
          id="title"
          v-model="region.title"
          required
          placeholder=""
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Страна" label-for="parent">
        <b-form-select v-model="region.country" class="mb-3">
          <option :value="null">Выберите страну</option>
          <option v-for="option in countries" :value="option.id" :key="option.id">{{ option.text }}</option>
        </b-form-select>
      </b-form-group>

      <b-form-group label="Статус" label-for="status">
        <b-form-select v-model="region.isActive" :options="statusOptions" class="mb-3"></b-form-select>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { slugify, objectToArraySafe } from '@/services/utils'

export default {
  props: {
    item: [Object]
  },
  data () {
    return {
      region: {
        title: '',
        slug: '',
        createdAt: '',
        isActive: true,
        country: ''
      }
    }
  },
  computed: {
    ...mapState({
      statusOptions: state => state.auth.statusOptions
    }),
    countries () {
      return objectToArraySafe(this.$store.getters.getCountries)
    },
    slug () {
      return slugify(this.region.title)
    },
    title () {
      if (this.item) {
        return 'Редактировать регион'
      } else {
        return 'Добавить регион'
      }
    }
  },
  methods: {
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid ? 'valid' : 'invalid'
      return valid
    },
    handleSubmit () {
      // Exit when the form isn't valid
      // if (!this.checkFormValidity()) {
      //   return
      // }
      const { region } = this
      if (this.item) {
        this.$store.dispatch('UPDATE_REGION', region).then((response) => {
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
      } else {
        this.region.slug = this.slug
        this.region.createdAt = this.$moment().format()
        this.$store.dispatch('CREATE_REGION', { region }).then((response) => {
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
      }
    },
    resetModal () {
      this.region.title = ''
      this.region.createdAt = ''
      this.region.slug = ''
      this.region.isActive = true
      this.region.country = ''
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
      if (this.item) {
        this.region.title = this.item.title
        this.region.createdAt = this.item.createdAt
        this.region.isActive = this.item.isActive
        this.region.slug = this.item.slug
        this.region.country = this.item.country
      }
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
  }
}
</script>